module.exports = __webpack_public_path__ + "static/media/pexels-tima-miroshnichenko-6764952.653c5399.jpg";